const MultipleSelectType = {
  filter: 'filter',
  userSpecialities: 'userSpecialities',
  themes: 'themes',
}

export default MultipleSelectType
